/** Paso común a las tres variantes de Google Ads. */
export const ENTER_ACCOUNT = `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Google Ads ({{url}}). Si ya está abierto, sigue.
2. Si entras por una cuenta de administrador (MCC), busca la cuenta de {{client}}. Customer ID(s) conocidos: {{accountIds}} (formato 123-456-7890). Si no hay ID, búscala por nombre; si hay varias, pregunta.
3. Comprueba que la moneda de la cuenta es {{goal.currency}}. Si no lo es, para y pregunta.
`;

export const BASE = {
  tool: "Google Ads",
  url: "https://ads.google.com/",
  idHint:
    'columna "Campaign ID" (añádela desde Columns si no se ve) o el parámetro campaignId de la URL',
  accountField: "googleAdsCustomerIds" as const,
};
